"use client";

import type { PropsWithChildren, RefObject } from "react";
import { createContext, useRef } from "react";

import type { BibleChapterRef } from "./BibleDisplay/BibleChapter";

export const BibleHeaderContext = createContext<{
  chapterRefs: RefObject<Record<string, BibleChapterRef>>;
  clearSelection: () => void;
}>({ clearSelection: () => {}, chapterRefs: { current: {} } });

export const BibleHeaderContextProvider = ({ children }: PropsWithChildren) => {
  const chapterRefs = useRef<Record<string, BibleChapterRef>>({});

  const clearSelection = () => {
    if (chapterRefs.current) {
      Object.values(chapterRefs.current).forEach((ref) =>
        ref?.clearSelection(),
      );
    }
  };

  return (
    <BibleHeaderContext.Provider value={{ chapterRefs, clearSelection }}>
      {children}
    </BibleHeaderContext.Provider>
  );
};
